import React, { Component } from 'react'
import Form from 'devextreme-react/form'
import { anuitasByInsurance, insurances } from 'dataSource/lookup'

class FormPensiunDipercepat extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formData: {},
    }

    this.formRef = React.createRef()

    this.formItems = [
      {
        itemType: 'group',
        colCount: 2,
        name: 'master',
        items: [
          {
            itemType: 'group',
            cssClass: 'group-form-group',
            caption: 'Saldo Peserta',
            name: 'saldoPeserta',
            items: [
              {
                dataField: 'totalSaldoMpl',
                label: {
                  text: 'Jumlah Saldo + Manfaat Lain',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  format: '#,##0.00',
                  readOnly: true,
                },
              },
              {
                dataField: 'klaimTax',
                label: {
                  text: 'Pajak',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  format: '#,##0.00',
                  readOnly: true,
                },
              },
              {
                dataField: 'klaimBiayaKomisi',
                label: {
                  text: 'Biaya/Komisi Penutupan Rekening',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  format: '#,##0.00',
                  readOnly: true,
                },
              },
              {
                dataField: 'klaimAmountNett',
                label: {
                  text: 'Saldo Bersih',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  format: '#,##0.00',
                  readOnly: true,
                },
              },
              {
                dataField: 'klaimMaxPersen',
                label: {
                  text: 'Maksimum Sekaligus (%)',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  format: '#,##0.00',
                  readOnly: true,
                },
              },
              {
                dataField: 'klaimMaxNominal',
                label: {
                  text: 'Maksimum Penarikan Sekaligus (Rp.)',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  format: '#,##0.00',
                  readOnly: true,
                },
              },
              {
                dataField: 'mpSekaligus',
                label: {
                  text: 'Pembayaran Manfaat Pensiun Yang di kehendaki',
                },
                editorType: 'dxRadioGroup',
                editorOptions: {
                  layout: 'horizontal',
                  items: [
                    {
                      value: 1,
                      text: 'Sekaligus 100%',
                    },
                    {
                      value: 2,
                      text: 'Atau Sebagian (%)',
                    },
                  ],
                  onValueChanged: (e) => {
                    if (e.value) {
                      let values = e.value.value
                      let persentaseEditor =
                        this.formRef.current.instance.getEditor('klaimPersen')
                      let pilihanProduk =
                        this.formRef.current.instance.getEditor('pilihanProduk')

                      if (values === 2) {
                        persentaseEditor.option('readOnly', false)
                        persentaseEditor.option('value', 0)
                        persentaseEditor.option('elementAttr', {
                          class: 'bd-input-popup-dapen-default',
                        })

                        pilihanProduk.option('readOnly', false)
                        pilihanProduk.option('elementAttr', {
                          class: 'bd-input-popup-dapen-default',
                        })
                      } else {
                        persentaseEditor.option('readOnly', true)
                        persentaseEditor.option('value', 100)
                        persentaseEditor.option('elementAttr', {
                          class: 'bd-input-popup-disabled-dapen-default',
                        })

                        pilihanProduk.option('readOnly', true)
                        pilihanProduk.option('elementAttr', {
                          class: 'bd-input-popup-disabled-dapen-default',
                        })
                      }
                    }
                  },
                },
              },
              {
                dataField: 'klaimPersen',
                label: {
                  visible: false,
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  format: '#0.00',
                  placeholder: 'Masukkan Persentase',
                  readOnly: true,
                },
              },
              {
                dataField: 'pilihanProduk',
                label: {
                  text: 'Pilihan Produk',
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                  dataSource: [
                    {
                      id: 1,
                      value: 'Berkala',
                    },
                    {
                      id: 2,
                      value: 'Anuitas',
                    },
                  ],
                  valueExpr: 'id',
                  displayExpr: 'value',
                  readOnly: true,
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  onValueChanged: (e) => {
                    if (e.value) {
                      let values = e.value
                      if (values === 2) {
                        this.formRef.current.instance.updateData({
                          pembelianAnuitas: true,
                        })

                        this.formRef.current.instance
                          .getEditor('pembelianAnuitasValue')
                          .option('readOnly', false)
                        this.formRef.current.instance
                          .getEditor('pembelianAnuitasValue')
                          .option('elementAttr', {
                            class: 'bd-input-popup-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('anuitasAsuransiId')
                          .option('readOnly', false)
                        this.formRef.current.instance
                          .getEditor('anuitasAsuransiId')
                          .option('elementAttr', {
                            class: 'bd-input-popup-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('anuitasProductId')
                          .option('readOnly', false)
                        this.formRef.current.instance
                          .getEditor('anuitasProductId')
                          .option('elementAttr', {
                            class: 'bd-input-popup-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('pembelianBerkalaValue')
                          .option('readOnly', true)
                        this.formRef.current.instance
                          .getEditor('pembelianBerkalaValue')
                          .option('elementAttr', {
                            class: 'bd-input-popup-disabled-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('berkalaTahunPembayaran')
                          .option('readOnly', true)
                        this.formRef.current.instance
                          .getEditor('berkalaTahunPembayaran')
                          .option('elementAttr', {
                            class: 'bd-input-popup-disabled-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('berkalaPeriodePembayaran')
                          .option('readOnly', true)
                        this.formRef.current.instance
                          .getEditor('berkalaPeriodePembayaran')
                          .option('elementAttr', {
                            class: 'bd-input-popup-disabled-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('berkalaTanggalPembayaran')
                          .option('readOnly', true)
                        this.formRef.current.instance
                          .getEditor('berkalaTanggalPembayaran')
                          .option('elementAttr', {
                            class: 'bd-input-popup-disabled-dapen-default',
                          })
                      } else {
                        this.formRef.current.instance.updateData({
                          pembelianBerkala: true,
                        })

                        this.formRef.current.instance
                          .getEditor('pembelianAnuitasValue')
                          .option('readOnly', true)
                        this.formRef.current.instance
                          .getEditor('pembelianAnuitasValue')
                          .option('elementAttr', {
                            class: 'bd-input-popup-disabled-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('anuitasAsuransiId')
                          .option('readOnly', true)
                        this.formRef.current.instance
                          .getEditor('anuitasAsuransiId')
                          .option('elementAttr', {
                            class: 'bd-input-popup-disabled-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('anuitasProductId')
                          .option('readOnly', true)
                        this.formRef.current.instance
                          .getEditor('anuitasProductId')
                          .option('elementAttr', {
                            class: 'bd-input-popup-disabled-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('pembelianBerkalaValue')
                          .option('readOnly', false)
                        this.formRef.current.instance
                          .getEditor('pembelianBerkalaValue')
                          .option('elementAttr', {
                            class: 'bd-input-popup-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('berkalaTahunPembayaran')
                          .option('readOnly', false)
                        this.formRef.current.instance
                          .getEditor('berkalaTahunPembayaran')
                          .option('elementAttr', {
                            class: 'bd-input-popup-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('berkalaPeriodePembayaran')
                          .option('readOnly', false)
                        this.formRef.current.instance
                          .getEditor('berkalaPeriodePembayaran')
                          .option('elementAttr', {
                            class: 'bd-input-popup-dapen-default',
                          })

                        this.formRef.current.instance
                          .getEditor('berkalaTanggalPembayaran')
                          .option('readOnly', false)
                        this.formRef.current.instance
                          .getEditor('berkalaTanggalPembayaran')
                          .option('elementAttr', {
                            class: 'bd-input-popup-dapen-default',
                          })
                      }
                    }
                  },
                },
              },
            ],
          },
          {
            itemType: 'group',
            cssClass: 'group-form',
            name: 'pembelian',
            caption:
              'Jika Pembayaran Manfaat Pensiun Sebagian, Pilih Produk Anuitas atau Berkala yang anda kehendaki:',
            items: [
              {
                dataField: 'pembelianAnuitasValue',
                label: {
                  text: 'Nilai Pembelian dalam Nominal (Rp)',
                  alignment: 'left',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  format: '#,##0.00',
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  readOnly: true,
                  placeholder: 'Nilai Pembelian dalam Nominal (Rp)',
                },
              },
              {
                dataField: 'anuitasAsuransiId',
                label: {
                  text: 'Perusahaan Asuransi Anuitas',
                  alignment: 'left',
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  dataSource: insurances(this.props.store),
                  valueExpr: 'id',
                  displayExpr: 'insuranceName',
                  readOnly: true,
                  placeholder: 'Perusahaan Asuransi Anuitas',
                  onValueChanged: async (e) => {
                    if (e.value) {
                      return this.formRef.current.instance
                        .getEditor('anuitasProductId')
                        .option(
                          'dataSource',
                          anuitasByInsurance(this.props.store, e.value)
                        )
                    }
                  },
                },
              },
              {
                dataField: 'anuitasProductId',
                label: {
                  text: 'Produk Anuitas',
                  alignment: 'left',
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  dataSource: [],
                  valueExpr: 'id',
                  displayExpr: 'anuitasName',
                  readOnly: true,
                  placeholder: 'Produk Anuitas',
                },
              },
              {
                itemType: 'empty',
              },
              {
                dataField: 'pembelianBerkalaValue',
                label: {
                  text: 'Nilai Pembelian dalam Nominal (Rp)',
                  alignment: 'left',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  format: '#,##0.00',
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  readOnly: true,
                  placeholder: 'Nilai Pembelian dalam Nominal (Rp)',
                },
              },
              {
                dataField: 'berkalaTahunPembayaran',
                label: {
                  text: 'Tahun Pembayaran Berkala',
                  alignment: 'left',
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  dataSource: [
                    {
                      id: 10,
                      value: '10 Tahun',
                    },
                    {
                      id: 15,
                      value: '15 Tahun',
                    },
                    {
                      id: 20,
                      value: '20 Tahun',
                    },
                    {
                      id: 25,
                      value: '25 Tahun',
                    },
                  ],
                  valueExpr: 'id',
                  displayExpr: 'value',
                  readOnly: true,
                  placeholder: 'Tahun Pembayaran Berkala',
                },
              },
              {
                dataField: 'berkalaPeriodePembayaran',
                label: {
                  text: 'Periode Pembayaran',
                  alignment: 'left',
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  dataSource: [
                    {
                      id: 1,
                      value: 'Bulanan',
                    },
                    {
                      id: 2,
                      value: '6 Bulanan',
                    },
                    {
                      id: 3,
                      value: 'Tahunan',
                    },
                  ],
                  valueExpr: 'id',
                  displayExpr: 'value',
                  readOnly: true,
                  placeholder: 'Periode Pembayaran',
                },
              },
              {
                dataField: 'berkalaTanggalPembayaran',
                label: {
                  text: 'Tanggal Pembayaran MP Berkala',
                  alignment: 'left',
                },
                editorType: 'dxDateBox',
                editorOptions: {
                  displayFormat: 'dd MMM yyyy',
                  useMaskBehavior: true,
                  openOnFieldClick: true,
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  readOnly: true,
                  placeholder: 'Tanggal Pembayaran MP Berkala',
                },
              },
            ],
          },
        ],
      },
    ]
  }

  loadData = async (data) => {
    this.formRef.current.instance.updateData(data)
  }

  clearData = () => {
    this.setState({ formData: {} })
  }

  sendData = () => {
    return this.state.formData
  }

  render() {
    return (
      <React.Fragment>
        <Form
          id={'pensiunNormal'}
          ref={this.formRef}
          colCount={1}
          formData={this.state.formData}
          items={this.formItems}
          labelLocation="left"
        />
        <i>
          Jika tanggal klaim sebelum tanggal 15 Pembayaran berkala di lakukan
          setiap tanggal 5, Jika setelah tanggal 15 Pembayaran tanggal 23.
          Tanggal Pembayaran Pertama dilakukan dibulan setelah tanggal klaim
        </i>
      </React.Fragment>
    )
  }
}

export default FormPensiunDipercepat
